import { ProfileTier } from '@fcom/core-api/login';

export const LEGACY_SITE_TIER_CODES = {
  [ProfileTier.BASIC]: 1,
  [ProfileTier.SILVER]: 2,
  [ProfileTier.GOLD]: 3,
  [ProfileTier.PLATINUM]: 4,
  [ProfileTier.LUMO]: 14,
  [ProfileTier.JUNIOR]: 11,
};
